/* Medialuna illustration engine — parametric SVG, no external images */
window.ML = (function () {
  function rng(seed) {
    let a = seed >>> 0 || 1;
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  const D = Math.PI / 180;
  const R = 58, CY = 40, SPAN = 84; // arc geometry (unit medialuna ~ 190 x 110)

  function arcPt(t, off) {
    const a = (-90 + t * SPAN) * D;
    const r = R + (off || 0);
    return [r * Math.cos(a), CY + r * Math.sin(a), a];
  }
  function lobeR(t) { return 5 + 22 * Math.pow(Math.max(0, 1 - t * t), 0.75); }

  function defs() {
    return `
    <radialGradient id="mlBake" cx="42%" cy="36%" r="70%">
      <stop offset="0" stop-color="#FFE3A1"/><stop offset=".38" stop-color="#F0AE4E"/>
      <stop offset=".78" stop-color="#C2701F"/><stop offset="1" stop-color="#8E4512"/>
    </radialGradient>
    <radialGradient id="mlBakeRaw" cx="42%" cy="36%" r="70%">
      <stop offset="0" stop-color="#FFF4DC"/><stop offset=".5" stop-color="#F6E1B8"/>
      <stop offset="1" stop-color="#D9B983"/>
    </radialGradient>
    <radialGradient id="mlShadow" cx="50%" cy="50%" r="50%">
      <stop offset="0" stop-color="#3A1E08" stop-opacity=".24"/><stop offset="1" stop-color="#3A1E08" stop-opacity="0"/>
    </radialGradient>
    <linearGradient id="mlGloss" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fff" stop-opacity=".85"/><stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </linearGradient>`;
  }

  const FILL = {
    rellena: ["#F7DB8E", "#E9BE5C"],
    jyq: ["#F8D24F", "#E7848A"],
    pistacho: ["#A6C062", "#7E9A3C"],
    choco: ["#FFF3DD", "#A6C062"],
  };

  function path(pts) { return "M" + pts.map(p => p[0].toFixed(1) + " " + p[1].toFixed(1)).join("L"); }

  function arcPath(t0, t1, off, n) {
    const pts = [];
    for (let i = 0; i <= n; i++) pts.push(arcPt(t0 + (t1 - t0) * (i / n), off));
    return path(pts);
  }

  function zig(t0, t1, n, amp, rnd, offBase) {
    const pts = [];
    for (let i = 0; i <= n; i++) {
      const t = t0 + (t1 - t0) * (i / n);
      const w = lobeR(t) * amp;
      const off = (offBase || 0) + (i % 2 ? w : -w) + (rnd() - 0.5) * 5;
      const p = arcPt(t + (rnd() - 0.5) * 0.04, off);
      pts.push(p);
    }
    // smooth with quadratic curves
    let d = `M${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
    for (let i = 1; i < pts.length - 1; i++) {
      const mx = (pts[i][0] + pts[i + 1][0]) / 2, my = (pts[i][1] + pts[i + 1][1]) / 2;
      d += `Q${pts[i][0].toFixed(1)} ${pts[i][1].toFixed(1)} ${mx.toFixed(1)} ${my.toFixed(1)}`;
    }
    const l = pts[pts.length - 1];
    return d + `L${l[0].toFixed(1)} ${l[1].toFixed(1)}`;
  }

  /* opts: variant, seed, raw (unbaked), gloss (0..1), shadow */
  function one(o) {
    o = Object.assign({ variant: "clasica", seed: 1, gloss: 1, shadow: true, raw: false }, o);
    const rnd = rng(o.seed * 9301 + 17);
    const v = o.variant;
    let s = "";
    if (o.shadow) s += `<ellipse cx="3" cy="${CY - R * 0.62 + 10}" rx="${R + 26}" ry="${R * 0.62}" fill="url(#mlShadow)"/>`;
    const fillRef = o.raw ? "url(#mlBakeRaw)" : "url(#mlBake)";
    const strokeC = o.raw ? "#B8955C" : "#7A3A0E";
    // body crescent
    const outer = [], inner = [];
    for (let i = 0; i <= 40; i++) {
      const t = -1.06 + 2.12 * (i / 40);
      outer.push(arcPt(t, lobeR(t) * 0.92));
      inner.push(arcPt(t, -lobeR(t) * 0.8));
    }
    s += `<path d="${path(outer.concat(inner.reverse()))}Z" fill="${fillRef}" stroke="${strokeC}" stroke-opacity=".3" stroke-width="1.2" stroke-linejoin="round"/>`;
    // bands (lamination): from tips to center
    const n = 9, order = [];
    for (let i = 0; i < n; i++) order.push(-1 + (2 * i) / (n - 1));
    order.sort((a, b) => Math.abs(b) - Math.abs(a));
    order.forEach(t => {
      const [x, y, a] = arcPt(t, 0.5);
      const rr = lobeR(t) * (0.95 + rnd() * 0.08);
      const rt = 5 + 10 * (1 - 0.5 * t * t);
      s += `<ellipse cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" rx="${rr.toFixed(1)}" ry="${rt.toFixed(1)}" transform="rotate(${(a / D).toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})" fill="${fillRef}" stroke="${strokeC}" stroke-opacity=".28" stroke-width="1"/>`;
    });
    // filling slit
    if (!o.raw && FILL[v] && v !== "choco") {
      const [c1, c2] = FILL[v];
      s += `<path d="${arcPath(-0.62, 0.62, 2, 24)}" fill="none" stroke="#6B300B" stroke-opacity=".5" stroke-width="11" stroke-linecap="round"/>`;
      s += `<path d="${arcPath(-0.6, 0.6, 2, 24)}" fill="none" stroke="${c1}" stroke-width="8" stroke-linecap="round"/>`;
      if (v === "jyq") s += `<path d="${zig(-0.55, 0.55, 14, 0.06, rnd, 3)}" fill="none" stroke="${c2}" stroke-width="4" stroke-linecap="round"/>`;
      else s += `<path d="${arcPath(-0.5, 0.5, 0.5, 20)}" fill="none" stroke="${c2}" stroke-opacity=".7" stroke-width="2.5" stroke-linecap="round"/>`;
    }
    // gloss (almíbar)
    if (!o.raw && o.gloss > 0) {
      s += `<g opacity="${(0.75 * o.gloss).toFixed(2)}">`;
      s += `<path d="${arcPath(-0.72, 0.5, 9, 24)}" fill="none" stroke="#fff" stroke-opacity=".35" stroke-width="4" stroke-linecap="round"/>`;
      for (let i = 0; i < 11; i++) {
        const t = -0.9 + (1.8 * i) / 10;
        const [x, y, a] = arcPt(t, lobeR(t) * 0.35);
        s += `<ellipse cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" rx="${(3 + rnd() * 2).toFixed(1)}" ry="1.6" transform="rotate(${(a / D + 90).toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})" fill="#fff" fill-opacity=".8"/>`;
      }
      s += `</g>`;
    }
    // toppings
    if (!o.raw && (v === "rellena")) {
      for (let i = 0; i < 90; i++) {
        const t = -0.95 + rnd() * 1.9;
        const off = (rnd() - 0.6) * lobeR(t) * 1.3;
        const [x, y] = arcPt(t, off);
        s += `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${(0.7 + rnd() * 1.4).toFixed(1)}" fill="#fff" fill-opacity="${(0.65 + rnd() * 0.35).toFixed(2)}"/>`;
      }
    }
    if (!o.raw && v === "pistacho") {
      s += `<path d="${zig(-0.8, 0.8, 11, 0.55, rnd, -6)}" fill="none" stroke="#8FAE4A" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/>`;
      for (let i = 0; i < 22; i++) {
        const t = -0.8 + rnd() * 1.6;
        const [x, y] = arcPt(t, (rnd() - 0.65) * lobeR(t));
        const c = rnd() > 0.7 ? "#7C5A7A" : rnd() > 0.4 ? "#6E8F2E" : "#C9D88C";
        s += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${(2 + rnd() * 2).toFixed(1)}" height="${(1.6 + rnd() * 1.6).toFixed(1)}" rx=".6" transform="rotate(${(rnd() * 180).toFixed(0)} ${x.toFixed(1)} ${y.toFixed(1)})" fill="${c}"/>`;
      }
    }
    if (!o.raw && v === "choco") {
      s += `<path d="${zig(-0.85, 0.85, 12, 0.6, rnd, -5)}" fill="none" stroke="#FFF6E8" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>`;
      s += `<path d="${zig(-0.8, 0.8, 9, 0.5, rnd, -2)}" fill="none" stroke="#9A4F1C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>`;
    }
    const tr = `translate(0 ${-CY + R * 0.62})`;
    return `<g transform="${tr}">${s}</g>`;
  }

  /* Top-down box with n medialunas */
  function box(o) {
    o = Object.assign({ variant: "clasica", count: 6, w: 400, h: 300, seed: 7, mix: null }, o);
    const rnd = rng(o.seed);
    const cols = o.count === 12 ? 4 : 3, rows = o.count === 12 ? 3 : 2;
    const pad = 26, bw = o.w - pad * 2, bh = o.h - pad * 2;
    let s = `<rect x="${pad - 10}" y="${pad - 6}" width="${bw + 20}" height="${bh + 20}" rx="14" fill="#2C2017" opacity=".12"/>`;
    s += `<rect x="${pad - 12}" y="${pad - 12}" width="${bw + 24}" height="${bh + 24}" rx="14" fill="var(--box,#9CCBEF)"/>`;
    s += `<rect x="${pad}" y="${pad}" width="${bw}" height="${bh}" rx="6" fill="var(--liner,#FFF9EF)"/>`;
    // liner pattern: tiny suns
    const cw = bw / cols, ch = bh / rows;
    const sc = Math.min(cw / 165, ch / 100);
    let k = 0, shadows = "", items = "";
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      const x = pad + cw * (c + 0.5) + (rnd() - 0.5) * 6;
      const y = pad + ch * (r + 0.5) + (rnd() - 0.5) * 6;
      const rot = (rnd() - 0.5) * 22 + (r % 2 ? 180 : 0);
      const v = o.mix ? o.mix[k % o.mix.length] : o.variant;
      shadows += `<ellipse cx="${(x + 4).toFixed(1)}" cy="${(y + 9).toFixed(1)}" rx="${(92 * sc).toFixed(1)}" ry="${(46 * sc).toFixed(1)}" fill="url(#mlShadow)"/>`;
      items += `<g transform="translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${rot.toFixed(1)}) scale(${sc.toFixed(3)})"><g transform="translate(0 ${(-R * 0.25).toFixed(1)})">${one({ variant: v, seed: o.seed * 31 + k, shadow: false })}</g></g>`;
      k++;
    }
    return s + shadows + items;
  }

  /* Sol de mayo: rayos rectos y flamígeros alternados (viewBox -200 -200 400 400) */
  function sun() {
    let s = "";
    const n = 32;
    for (let i = 0; i < n; i++) {
      const a = (i / n) * Math.PI * 2;
      const r0 = 112, r1 = i % 2 ? 176 : 196;
      if (i % 2 === 0) {
        const w = 0.035;
        const p = [[r0, a - w], [r1, a], [r0, a + w]].map(([r, t]) => `${(r * Math.cos(t)).toFixed(1)} ${(r * Math.sin(t)).toFixed(1)}`);
        s += `<path d="M${p[0]}L${p[1]}L${p[2]}Z" fill="currentColor"/>`;
      } else {
        let d = "";
        for (let k = 0; k <= 14; k++) {
          const r = r0 + (r1 - r0) * (k / 14);
          const t = a + Math.sin(k * 0.9) * 0.03 * (1 - k / 18);
          d += (k ? "L" : "M") + (r * Math.cos(t)).toFixed(1) + " " + (r * Math.sin(t)).toFixed(1);
        }
        s += `<path d="${d}" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>`;
      }
    }
    return s + `<circle r="100" fill="currentColor" opacity=".22"/><circle r="100" fill="none" stroke="currentColor" stroke-width="3"/>`;
  }
  return { one, box, defs, sun };
})();
